import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';

const LOGIN_TOKEN_KEY = 'my_login_token';
const Sub_Url = 'http://iilrms.platform.simplifii.com/api/v1/cards/all?type=SubmissionCycle&equalto___valid=1';
const User_Url = 'http://auth.simplifii.com/users/authenticate';

@Injectable()
export class Service {
  constructor(private http: HttpClient) {
  }

  getTable(datefrom: string, dateto: string, token: string): Observable<any> {
    const base_url = localStorage.getItem('loginurl');
    return this.http.get<any>(base_url + '/api/v1/cards/all?type=Claim&greaterthanequalto___date=' + datefrom + ' 00:00:00&lessthanequalto___date=' + dateto + ' 00:00:00&state=Approved&sort_by=+datetime1&token=' + token + '&creator=' + localStorage.getItem('id')).map(value => {
      console.log(value);
      return value.response.data;
    });
  }

  login(data): Observable<string> {
    const Login_url = localStorage.getItem('loginurl') + '/api/v1/admin/authenticate'
    return this.http.post<any>(Login_url, {
      username: localStorage.getItem('username'),
      password: data.password
    }).map((value) => {
      localStorage.setItem(LOGIN_TOKEN_KEY, value.token);
      localStorage.setItem('name', value.response.name);
      localStorage.setItem('level', value.response.int3);
      localStorage.setItem('state', value.response.string4);
      localStorage.setItem('city', value.response.string5);
      localStorage.setItem('id', value.response.id);
      localStorage.setItem('empid', value.response.emp_code);
      localStorage.setItem('mobile', value.response.mobile);
      localStorage.setItem('logo', value.response.constants.logo);
      localStorage.setItem('fkorg', value.response.fk_org);
      localStorage.setItem('area', value.response.ht_user_id);
      localStorage.setItem('zone', value.response.string10);
      return value.response;
    });
  }

  getSubmision(): Observable<any> {
    const base_url = localStorage.getItem('loginurl');
    const headers = new HttpHeaders().set('Authorization', 'bearer ' + localStorage.getItem(LOGIN_TOKEN_KEY));
    return this.http.get<any>(base_url + '/api/v1/cards/all?type=SubmissionCycle&equalto___valid=1', {
      headers: headers
    }).map(value => {
      return value.response.data;
    });
  }

  initialLogin(data): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.patch<any>(User_Url,
      {
        mobile: data.username
      }, {headers: headers}
    ).map(value => {
      localStorage.setItem('username', value.response.central_data.username);
      localStorage.setItem('loginurl', value.response.central_data.base_url);
      return value.response.central_data;
    });
  }
}



// WEBPACK FOOTER //
// /home/ashutosh/submission/src/app/service.ts